import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	},
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
			path: '*',
			redirect: '/404',
		},
		{
			path: '/404',
			name: 'error',
			component: () => import( /* webpackChunkName: "download" */ '@/views/404.vue'),
			meta: {
				title: '404 Page Not Found'
			}
		},

		{
			path: '/download',
			redirect: '/',
		},
		{
			path: '/',
			name: 'Download',
			component: () => import( /* webpackChunkName: "download" */
				'@/views/download-page/download.vue'),
			meta: {
				title: 'common.jgz_down'
			}
		},
		{
			path: '/cannotAccess',
			name: 'cannotAccess',
			component: () => import('@/views/cannotAccess/cannotAccess.vue'),
			meta: {
				title: 'cannotAccess'
			}
		},
		// {
		//     path: '/home',
		//     name: 'Home',
		//     component: () => import(/* webpackChunkName: "home" */ '@/views/home.vue'),
		// },
		{
			path: '/invitation',
			name: 'Invitation',
			component: () => import( /* webpackChunkName: "invitation" */ '@/views/invitation.vue'),
		},
		{
			path: '/invitation-xp',
			name: 'Invitation-xp',
			component: () => import( /* webpackChunkName: "invitation" */ '@/views/invitation-xp.vue'),
			meta: {
				title: '邀请好友'
			}
		},
		// {
		//     path: '/open-app',
		//     name: 'OpenApp',
		//     component: () => import(/* webpackChunkName: "openApp" */ '@/views/download-page/invitationDownload.vue'),
		//     meta: {
		//         title: '金果子下载'
		//     }
		// },
		{
			path: '/score-introduce',
			name: 'ScoreIntroduce',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/scoreIntroduce.vue'),
			meta: {
				title: '了解积分'
			}
		},
		{
			path: '/score-conversion',
			name: 'ScroeConversion',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/scoreConversion.vue'),
			meta: {
				title: '积分兑换'
			}
		},
		{
			path: '/notification-introduce',
			name: 'NotificationIntro',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/notificationIntro.vue'),
			meta: {
				title: '关于通知中心行情'
			}
		},
		{
			path: '/test-app',
			name: 'TestApp',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */ '@/views/testApp.vue'),
			meta: {
				title: '测试打开页面'
			}
		},

		{
			path: '/bonus',
			name: 'Bonus',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */ '@/views/bonus.vue'),
			meta: {
				title: '关于赠金'
			}
		},

		{
			path: '/activeXP',
			name: 'activeXP',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/activeXP.vue'),
			meta: {
				title: '新用户注册豪礼'
			}
		},
		{
			path: '/bonus_activity',
			name: 'BonusActivity',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/bonusActivity.vue'),
			meta: {
				title: '赠金活动'
			}
		},
		{
			path: '/newyear-p1',
			name: 'NewYearDetail1',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/newYear/p1.vue'),
			meta: {
				title: 'JGZQuant半月8倍收益'
			}
		},
		{
			path: '/newyear-p2',
			name: 'NewYearDetail2',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/newYear/p2.vue'),
			meta: {
				title: 'JGZQuant半月8倍收益'
			}
		},
		{
			path: '/newyear-p3',
			name: 'NewYearDetail3',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/newYear/p3.vue'),
			meta: {
				title: 'JGZQuant半月8倍收益'
			}
		},
		{
			path: '/new-intro-en',
			name: 'NewIntroEn',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/phone17/index.vue'),
			meta: {
				title: 'JGZ交易狂欢节'
			}
		},
		{
			path: '/new-intro',
			name: 'NewIntro',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/phone17/index.vue'),
			meta: {
				title: 'JGZ交易狂欢节'
			}
		},
		{
			path: '/new-intro1',
			name: 'NewIntro1',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/newIntro.vue'),
			meta: {
				title: 'JGZ'
			}
		},
		{
			path: '/new-intro2',
			name: 'NewIntro2',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/newIntro2.vue'),
			meta: {
				title: 'JGZ'
			}
		},

		{
			path: '/prodownload',
			name: 'BetaDownload',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/download-page/betaDown.vue'),
			meta: {
				title: '金果子Pro下载'
			}
		},

		{
			path: '/1101test-down',
			name: 'TestDownload',
			component: () => import( /* webpackChunkName: "TestDownload" */
				'@/views/download-page/testDown.vue'),
			meta: {
				title: '金果子下载-内部测试版'
			}
		},

		{
			path: '/usual-active',
			name: 'UsualActive',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/active/usualActive.vue'),
			meta: {
				title: '金果子活动'
			}
		},
		{
			path: '/notice',
			name: 'Notice',
			component: () => import( /* webpackChunkName: "Notice" */ '@/views/notice/notice.vue'),
			meta: {
				title: '金果子公告'
			}
		},
		{
			path: '/notice-xp',
			name: 'Notice-xp',
			component: () => import( /* webpackChunkName: "Notice" */ '@/views/notice/notice-xp.vue'),
			meta: {
				title: 'XP Notice'
			}
		},
		{
			path: '/activity',
			name: 'ProDownload',
			redirect: '/activity/ad_001',
			component: () => import( /* webpackChunkName: "ProAd" */
				'@/views/download-page/pro-download/index.vue'),
			children: [{
					path: 'ad_001',
					name: 'ProDownload01',
					component: () => import( /* webpackChunkName: "ProAd1" */
						'@/views/download-page/pro-download/ad001.vue'),
					meta: {
						title: '金果子Pro版下载',
						fromTime: 1590768000000,
						endTime: 1591113600000
					},
				},
				{
					path: 'ad_002',
					name: 'ProDownload02',
					component: () => import( /* webpackChunkName: "ProAd2" */
						'@/views/download-page/pro-download/ad002.vue'),
					meta: {
						title: '瓜分活动',
						fromTime: 1599494400000,
						endTime: 1600099200000
					},
				},
				{
					path: 'ad_003',
					name: 'Down03',
					component: () => import( /* webpackChunkName: "ProAd3" */
						'@/views/download-page/pro-download/ad003.vue'),
					meta: {
						title: '空投活动',
						fromTime: 1599494400000,
						endTime: 1632153600000
					},
				},
				{
					path: 'ad_004',
					name: 'Down04',
					component: () => import( /* webpackChunkName: "ProAd4" */
						'@/views/download-page/pro-download/ad004.vue'),
					meta: {
						title: '雨露均沾',
						fromTime: 1599494400000,
						endTime: 1632153600000
					},
				},
				{
					path: 'ad_005',
					name: 'Down05',
					component: () => import( /* webpackChunkName: "ProAd4" */
						'@/views/download-page/pro-download/ad005.vue'),
					meta: {
						title: '金果子量化',
						fromTime: 1599494400000,
						endTime: 1632153600000
					},
				},
				{
					path: 'fxh_active',
					name: 'Down05',
					component: () => import( /* webpackChunkName: "ProAd4" */
						'@/views/download-page/pro-download/fxh.vue'),
					meta: {
						title: '非小号瓜分活动',
						fromTime: 1599494400000,
						endTime: 1660891705000
					},
				}
			],

		},
		{
			path: '/platform-fxh-down',
			name: 'PlatformFxhDown',
			component: () => import( /* webpackChunkName: "FxhDown" */
				'@/views/download-page/pro-download/platform/fxhDown.vue'),
			meta: {
				title: '金果子Pro版下载',
				fromTime: 1599494400000,
				endTime: 1660891705000
			},
		},
		{
			path: '/user-guide',
			name: 'UserDownloadGuide',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/download-page/userDownloadGuide.vue'),
			meta: {
				title: '金果子下载引导'
			}
		},
		{
			path: '/score-exchange',
			// name: 'ScoreExchagne',
			// component: () => import(/* webpackChunkName: "ScoreIntroduce" */ '@/views/score/scoreExchange.vue'),
			// meta: {
			//     title: '积分兑换'
			// }
			redirect: '/score-exchange/gzt'
		},
		{
			path: '/score-exchange/gzt',
			name: 'ScoreExchagne',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/score/scoreExchange.vue'),
			meta: {
				title: '积分兑换'
			}
		},
		{
			path: '/buy-back',
			name: 'BuyBack',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/buy-back/buyBack.vue'),
			meta: {
				title: 'GZT官方回购活动（第一期）'
			}
		},
		{
			path: '/about-alarm',
			name: 'AboutAlarm',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/alarm/aboutAlarm.vue'),
			meta: {
				title: '关于预警'
			}
		},
		{
			path: '/team-pk',
			name: 'TeamPk',
			redirect: '/team-pk/rule',
			component: () => import( /* webpackChunkName: "TeamPk" */ '@/views/active/team-pk/index.vue'),
			children: [{
					path: 'rule',
					name: 'TeamPkRule',
					component: () => import( /* webpackChunkName: "TeamPk-rules" */
						'@/views/active/team-pk/rule.vue'),
					meta: {
						title: '战队PK赛-活动规则'
					},
				},
				{
					path: 'member',
					name: 'TeamPkMember',
					component: () => import( /* webpackChunkName: "TeamPk-member" */
						'@/views/active/team-pk/member.vue'),
					meta: {
						title: '战队PK赛-成员',
					},
				},
				{
					path: 'live',
					name: 'TeamPkLive',
					component: () => import( /* webpackChunkName: "TeamPk-live" */
						'@/views/active/team-pk/live.vue'),
					meta: {
						title: '战队PK赛-赛况直播',
						// disable: true
					},
				},
				{
					path: 'result',
					name: 'TeamPkResult',
					component: () => import( /* webpackChunkName: "TeamPk-result" */
						'@/views/active/team-pk/result.vue'),
					meta: {
						title: '战队PK赛-比赛结果',
						// disable: true
					},
				}
			],
		},
		{
			path: '/team-pk2',
			name: 'TeamPk2',
			redirect: '/team-pk2/rule',
			component: () => import( /* webpackChunkName: "TeamPk" */ '@/views/active/team-pk2/index.vue'),
			children: [{
					path: 'rule',
					name: 'TeamPkRule2',
					component: () => import( /* webpackChunkName: "TeamPk-rules" */
						'@/views/active/team-pk2/rule.vue'),
					meta: {
						title: '战队PK赛-活动规则'
					},
				},
				{
					path: 'member',
					name: 'TeamPkMember2',
					component: () => import( /* webpackChunkName: "TeamPk-member" */
						'@/views/active/team-pk2/member.vue'),
					meta: {
						title: '战队PK赛-成员',
					},
				},
				{
					path: 'live',
					name: 'TeamPkLive2',
					component: () => import( /* webpackChunkName: "TeamPk-live" */
						'@/views/active/team-pk2/live.vue'),
					meta: {
						title: '战队PK赛-赛况直播',
						// disable: true
					},
				},
				{
					path: 'result',
					name: 'TeamPkResult2',
					component: () => import( /* webpackChunkName: "TeamPk-result" */
						'@/views/active/team-pk2/result.vue'),
					meta: {
						title: '战队PK赛-比赛结果',
						// disable: true
					},
				}
			],
		},
		{
			path: '/course',
			name: 'Course',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */ '@/views/course/course.vue'),
			meta: {
				title: '教程'
			}
		},
		{
			path: '/course-xp',
			name: 'course-xp',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/course/course-xp.vue'),
			meta: {
				title: '教程'
			}
		},

		{
			path: '/quantitative-protocol',
			name: 'QuantitativeProtocol',
			component: () => import( /* webpackChunkName: "Protocol" */
				'@/views/protocol/quantitativeProtocol.vue'),
			meta: {
				title: 'JGZ Protocol'
			}
		},

		/**
		 * 定向邀请
		 */
		{
			path: '/fixed-invitation',
			name: 'FixedInvitation',
			component: () => import( /* webpackChunkName: "FixedInvitation" */
				'@/views/fixed-invitation/fixedInvitation.vue'),
			meta: {
				title: '定向邀请'
			}
		},
		{
			path: '/fixed-invitation-register',
			name: 'FixedInvitationRegister',
			component: () => import( /* webpackChunkName: "FixedInvitation" */
				'@/views/fixed-invitation/register.vue'),
			meta: {
				title: 'common.invite_regist'
			}
		},
		{
			path: '/fixed-invitation-code',
			name: 'FixedInvitationCode',
			component: () => import( /* webpackChunkName: "FixedInvitation" */
				'@/views/fixed-invitation/code.vue'),
			meta: {
				title: 'common.invite_regist'
			}
		},
		{
			path: '/fixed-invitation-success',
			name: 'FixedInvitationSuccess',
			component: () => import( /* webpackChunkName: "FixedInvitation" */
				'@/views/fixed-invitation/success.vue'),
			meta: {
				title: 'common.invite_regist'
			}
		},

		//xp  邀请注册下载
		{
			path: '/sign-in-xp',
			name: 'SignIn-xp',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/invitation-down/signIn-xp.vue'),
			meta: {
				title: 'common.invite_regist'
			}
		},
		{
			path: '/success-xp',
			name: 'success-xp',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/invitation-down/success-xp.vue'),
			meta: {
				title: 'common.invite_regist'
			}
		},
		{
			path: '/Download-xp',
			name: 'Download-xp',
			component: () => import( /* webpackChunkName: "download" */
				'@/views/download-page/download-xp.vue'),
			meta: {
				title: 'common.xp_down'
			}
		},
		/**
		 * 邀请注册下载
		 */
		{
			path: '/sign-in',
			name: 'SignIn',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/invitation-down/signIn.vue'),
			meta: {
				title: 'common.invite_regist'
			}
		},
		{
			path: '/sign-in-code',
			name: 'SignInCode',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/invitation-down/inputCode.vue'),
			meta: {
				title: 'common.invite_regist'
			}
		},
		{
			path: '/sign-in-success',
			name: 'SignInSuccess',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/invitation-down/success.vue'),
			meta: {
				title: 'common.invite_regist'
			}
		},

		/**
		 * 非小号专属带统计下载页面
		 */
		{
			path: '/sign-in-fromfxh',
			name: 'SignInFxh',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/invitation-down/signIn.vue'),
			meta: {
				title: 'common.invite_regist',
				from: 'fxh'
			}
		},
		{
			path: '/sign-in-code-fromfxh',
			name: 'SignInCodeFxh',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/invitation-down/inputCode.vue'),
			meta: {
				title: 'common.invite_regist',
				from: 'fxh'
			}
		},
		{
			path: '/sign-in-success-fromfxh',
			name: 'SignInSuccessFxh',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/invitation-down/success.vue'),
			meta: {
				title: 'common.invite_regist',
				from: 'fxh'
			}
		},
		{
			path: '/down-fromfxh',
			name: 'DownloadFromFxh',
			component: () => import( /* webpackChunkName: "download" */ '@/views/fxh-down/download.vue'),
			meta: {
				title: 'APP下载'
			}
		},
		{
			path: '/user-guide-fromfxh',
			name: 'UserDownloadGuideFxh',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */
				'@/views/download-page/userDownloadGuide.vue'),
			meta: {
				title: 'APP下载引导',
				from: 'fxh'
			}
		},
		{
			path: '/kyc',
			name: 'KYC',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */ '@/views/KYC/index.vue'),
		},
		{
			path: '/kyc-result',
			name: 'KYCResult',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */ '@/views/KYC/result.vue'),
		},
		{
			path: '/apk1-52516',
			name: 'ChannelOne',
			component: () => import( /* webpackChunkName: "download" */
				'@/views/download-page/channelApk1.vue'),
			meta: {
				title: 'APP Download'
			}
		},
		{
			path: '/kyc/bulletin',
			name: 'bulletin',
			component: () => import( /* webpackChunkName: "ScoreIntroduce" */ '@/views/KYC/bulletin.vue'),
		},

		{
			path: '/apk2-58946',
			name: 'Channel2-58946-VLJEAF',
			component: () => import( /* webpackChunkName: "download" */
				'@/views/download-page/channelApk2.vue'),
			meta: {
				title: 'APP Download'
			}
		},
		// {
		//     path: '/',
		//     name: 'Channel1-52516-VU9SA7',
		//     component: () => import(/* webpackChunkName: "download" */ '@/views/download-page/channelApk1.vue'),
		//     meta: {
		//         title: 'APP Download'
		//     }
		// },
		// {
		//     path: '/',
		//     name: 'Channel3-59515-lVT8NAS',
		//     component: () => import(/* webpackChunkName: "download" */ '@/views/download-page/channelApkVT8NAS.vue'),
		//     meta: {
		//         title: 'APP Download'
		//     }
		// },
		// {
		//     path: '/turntable',
		//     name: 'turntable',
		//     component: () => import(/* webpackChunkName: "turntable" */ '@/views/turntable/index.vue'),
		// },
		{
			path: '/newyear_activity',
			name: 'newyear_activity',
			component: () => import( /* webpackChunkName: "turntable" */
				'@/views/turntable/gridRobot.vue'),
		},
		{
			path: '/okxActivity',
			name: 'okxActivity',
			component: () => import( /* webpackChunkName: "turntable" */
				'@/views/turntable/okxActivity.vue'),
		},
		{
			path: '/okxTransaction',
			name: 'okxTransaction',
			component: () => import( /* webpackChunkName: "turntable" */
				'@/views/turntable/okxTransaction.vue'),
		},

	]
})